import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import TournamentViewBreadcrumbTitle from '../components/TournamentViewBreadcrumbTitle'
import { LoadingSpinner } from '../../common'

const TournamentViewBreadcrumbTitleContainer = ({
  loading, loaded, ...rest
}) => {
  if (loading) {
    return <LoadingSpinner />
  }

  return loaded && <TournamentViewBreadcrumbTitle {...rest} />
}

TournamentViewBreadcrumbTitleContainer.propTypes = {
  loading: PropTypes.bool.isRequired,
  loaded: PropTypes.bool.isRequired,
}

const mapStateToProps = ({
  tournament: {
    summary: {
      loading,
      loaded,
      data: tournament,
    },
  },
}) => ({
  loading,
  loaded,
  tournament,
})

export default connect(mapStateToProps)(TournamentViewBreadcrumbTitleContainer)
